import { Transaction } from '@/types/rewardCard';
interface ResultByDay {
  [key: string]: Transaction[];
}
const keyTransactionsByDate = (transactions: Transaction[]): ResultByDay[] => {
  return transactions
    .reduce((acc: ResultByDay[], result: Transaction) => {
      const transactionDay = result.transaction_day;
      const existingDayIndex = acc.findIndex((day) => Object.keys(day)[0] === transactionDay);

      if (existingDayIndex !== -1) {
        // Append to existing day
        acc[existingDayIndex][transactionDay].push(result);
      } else {
        // Create a new day entry
        const newDayEntry: ResultByDay = {
          [transactionDay]: [result]
        };
        acc.push(newDayEntry);
      }

      return acc;
    }, [])
    .sort((a, b) => new Date(Object.keys(b)[0]).getTime() - new Date(Object.keys(a)[0]).getTime());
};

export default keyTransactionsByDate;
